class GalleryCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[id^="GalleryCarouselTrack"]');
    this.slides = Array.from(this.track.children);
    this.dotsWrapper = root.querySelector('[id^="GalleryCarouselDots"]');
    this.prevBtn = root.querySelector('.gallery-carousel__arrow--prev');
    this.nextBtn = root.querySelector('.gallery-carousel__arrow--next');

    this.slideCount = this.slides.length;
    if (this.slideCount === 0) return;

    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.slideWidth = 0;

    this.buildDots();
    this.bindEvents();
    this.update(false);

    // Recalculate on resize since slide width is percentage-based
    window.addEventListener('resize', () => this.update(false));
  }

  buildDots() {
    if (!this.dotsWrapper) return;
    this.dots = this.slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gallery-carousel__dot';
      dot.setAttribute('aria-label', `Go to image ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrapper.appendChild(dot);
      return dot;
    });
  }

  bindEvents() {
    // Arrows
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    // Touch events
    this.track.addEventListener('touchstart', (e) => this.dragStart(e), { passive: true });
    this.track.addEventListener('touchmove', (e) => this.dragMove(e), { passive: true });
    this.track.addEventListener('touchend', () => this.dragEnd());

    // Mouse events (desktop drag)
    this.track.addEventListener('mousedown', (e) => this.dragStart(e));
    this.track.addEventListener('mousemove', (e) => this.dragMove(e));
    this.track.addEventListener('mouseup', () => this.dragEnd());
    this.track.addEventListener('mouseleave', () => {
      if (this.isDragging) this.dragEnd();
    });
  }

  getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  dragStart(event) {
    this.isDragging = true;
    this.startX = this.getPositionX(event);
    this.slideWidth = this.track.clientWidth;
    this.track.style.transition = 'none';
  }

  dragMove(event) {
    if (!this.isDragging) return;
    const currentX = this.getPositionX(event);
    const diff = currentX - this.startX;
    this.currentTranslate = this.prevTranslate + diff;
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  dragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;

    const movedBy = this.currentTranslate - this.prevTranslate;
    const threshold = this.slideWidth * 0.15;

    if (movedBy < -threshold) {
      this.goTo(this.currentIndex + 1);
    } else if (movedBy > threshold) {
      this.goTo(this.currentIndex - 1);
    } else {
      this.update(true);
    }
  }

  goTo(index) {
    // Loop around
    if (index < 0) {
      this.currentIndex = this.slideCount - 1;
    } else if (index >= this.slideCount) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = index;
    }
    this.update(true);
  }

  update(animate) {
    this.slideWidth = this.track.clientWidth;
    this.prevTranslate = -this.currentIndex * this.slideWidth;
    this.currentTranslate = this.prevTranslate;

    this.track.style.transition = animate ? 'transform 0.35s ease' : 'none';
    this.track.style.transform = `translateX(${this.prevTranslate}px)`;

    if (this.dots) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.currentIndex);
      });
    }
  }
}

document.querySelectorAll('.gallery-carousel').forEach((el) => new GalleryCarousel(el));